export const legacyBusylightMessage = `You have connected unsupported Kuando Busylight (v1).

It cannot be remembered between sessions, and you will have to request it from the settings page on every startup.

This is resolved with the latest Kuando Busylight revision (v2)`;
